import { render, staticRenderFns } from "./staff_act_record.vue?vue&type=template&id=62b3c2e9&scoped=true&"
import script from "./staff_act_record.vue?vue&type=script&lang=js&"
export * from "./staff_act_record.vue?vue&type=script&lang=js&"
import style0 from "./staff_act_record.vue?vue&type=style&index=0&id=62b3c2e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b3c2e9",
  null
  
)

export default component.exports